/**
 * File: char.constant.ts
 * Version: 1.0.0
 * Project Name: Driftportal
 * Created Date: Friday August 23 2019
 * Created By: dung.ngo, email: dung.ngo@niteco.se
 * Author: Niteco
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2020 CGI Norway
 */

/**
 * This file contains constants that are simple characters or strings
 */
export const BLANK = '';
export const COLON = ':';
export const COMMA = ',';
export const SEMICOLON = ';';
export const SLASH = '/';
export const SPACE = ' ';
export const DOT = '.';
export const TAB = '\t';
export const LINE_BREAK = '\n';
export const PIXEL = 'px';
export const YEAR_PREFIX = `${new Date().getFullYear()}`.substr(0, 2);
export const ZERO = '0';
export const DASH = '-';
export const HASH = '#';
export const QUESTION_MARK = '?';
